import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { ListItem, Box, Typography } from '@mui/material';

/**
 * One sidebar nav row: an icon in a rounded chip (accent-filled when
 * active, theme.custom.chipBg otherwise) plus a label. Shared by
 * AccountMenu (project-scoped nav) and AppMenu (account-level nav) so
 * the active/inactive treatment stays identical everywhere.
 */
const NavItem = ({ to, icon, label, active }) => {
    return (
        <ListItem
            component={RouterLink}
            to={to}
            disableGutters
            sx={{
                display: 'flex', alignItems: 'center', gap: 1.5,
                px: 1.25, py: 0.9, mb: 0.4, borderRadius: 2.5,
                color: (theme) => (active ? theme.custom.text : theme.custom.muted),
                textDecoration: 'none',
            }}
        >
            <Box
                sx={{
                    width: 30, height: 30, borderRadius: '8px', flexShrink: 0,
                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                    backgroundColor: (theme) => (active ? theme.palette.primary.main : theme.custom.chipBg),
                    color: active ? '#fff' : 'inherit',
                    '& svg': { fontSize: 18 },
                }}
            >
                {icon}
            </Box>
            <Typography sx={{ fontSize: 14, fontWeight: active ? 600 : 500 }}>
                {label}
            </Typography>
        </ListItem>
    );
};

export default NavItem;
